module.exports = __webpack_public_path__ + "img/star-text.80436b5b.png";